// extracted by mini-css-extract-plugin
module.exports = {"item":"company-list_item__Gqp_P","icon":"company-list_icon___4aLM","active":"company-list_active__dHJIY","name":"company-list_name__mt0NA"};